export const capitalizeFirst = (str: string) =>
  `${str[0]?.toUpperCase()}${str.slice(1)}`
